import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { themeColorDark, themeColorLight } from '#shared/styles/theme-colors';
import AppleTouchIcon from '../../../../icons/site/apple-touch-icon.png';
import Favicon from '../../../../icons/site/favicon.ico';
import FaviconSVG from '../../../../icons/site/favicon.svg';
export function HTMLHead(t0) {
  const $ = _c(22);
  const {
    baseUrl,
    appUrl
  } = t0;
  let t1;
  if ($[0] !== baseUrl) {
    t1 = baseUrl && <base href={`${baseUrl}/`} />;
    $[0] = baseUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <meta charSet="utf-8" />;
    t3 = <meta content="ie=edge" httpEquiv="x-ua-compatible" />;
    t4 = <meta name="apple-mobile-web-app-title" content="BR24" />;
    t5 = <meta name="application-name" content="BR24" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = `${baseUrl}/api/browserconfig.xml`;
  let t7;
  if ($[6] !== t6) {
    t7 = <meta name="msapplication-config" content={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <link rel="icon" href={Favicon.src} sizes="32x32" />;
    t9 = <link rel="icon" href={FaviconSVG.src} type="image/svg+xml" />;
    t10 = <link rel="apple-touch-icon" href={AppleTouchIcon.src} />;
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  const t11 = `${baseUrl}/api/web-manifest`;
  let t12;
  if ($[11] !== t11) {
    t12 = <link rel="manifest" href={t11} />;
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <meta name="theme-color" media="(prefers-color-scheme: light)" key="light-mode" content={themeColorLight} />;
    t14 = <meta name="theme-color" media="(prefers-color-scheme: dark)" key="dark-mode" content={themeColorDark} />;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  const t15 = `${appUrl}/api/opensearch.xml`;
  let t16;
  if ($[15] !== t15) {
    t16 = <link type="application/opensearchdescription+xml" rel="search" href={t15} />;
    $[15] = t15;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== t1 || $[18] !== t12 || $[19] !== t16 || $[20] !== t7) {
    t17 = <Head>{t1}{t2}{t3}{t4}{t5}{t7}{t8}{t9}{t10}{t12}{t13}{t14}{t16}</Head>;
    $[17] = t1;
    $[18] = t12;
    $[19] = t16;
    $[20] = t7;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  return t17;
}